import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20geometric%20background%20with%20warm%20coral%20and%20amber%20gradients%2C%20soft%20flowing%20shapes%2C%20clean%20digital%20atmosphere%2C%20subtle%20texture%2C%20contemporary%20tech%20aesthetic%2C%20warm%20and%20inviting%20color%20palette%2C%20smooth%20gradient%20transitions%2C%20no%20text&width=1600&height=900&seq=hero-bg-91wang&orientation=landscape"
          alt="91网背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
          发现更多<strong className="text-primary-400">优质内容</strong>
          <br />
          满足您的<strong className="text-accent-400">多元需求</strong>
        </h2>
        <p className="mt-5 text-sm md:text-lg text-background-50/80 max-w-2xl mx-auto leading-relaxed">
          {siteInfo.description}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-200 text-sm md:text-base whitespace-nowrap cursor-pointer"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-background-50/30 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-all duration-200 text-sm md:text-base whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}